module.exports = __webpack_public_path__ + "static/img/10.81d1895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/10.png
// module id = wUXW
// module chunks = 0